// TopupDataColumns.js
import React from "react";
import { decimalTo } from '../../utils/utils';


// Utility to safely format to 2 decimal places
function safeToFixed(num) {
  return typeof num === "number" && !isNaN(num) ? decimalTo(num).toFixed(2) : "0.00";
}

export const TopupDataColumns = (handleRouteTopup,region) => {


  return [
    {
      name: "S.No",
      cell: (row, index) => (
        <>
          <input type="hidden" value={row.merchentId} />
          <span>{index + 1}</span>
        </>
      ),
      sortable: false,
    },
    {
      name: "Merchant",
      selector: (row) => row.merchent,
      cell: (row) => (
        <span href="#" onClick={() => handleRouteTopup(row)}>
          <span className="add-ellip wethislink">{row.merchent}</span>
        </span>
      ),
    },
    {
      name: `Amount${region?.currency ? ` (${region.currency})` : ''}`,
      selector: (row) => row.amount,
      cell: (row) => (
        <span className="add-ellip">{safeToFixed(row.amount)}</span>
      ),
    },
    {
      name: "Notes",
      selector: (row) => row.notes,
      cell: (row) => (
        <span className="add-ellip">{row.notes || "-"}</span>
      ),
    },
    {
      name: "Payment Date",
      selector: (row) => row.paymentDate,
    },
    {
      name: "Transaction Type",
      selector: (row) => row.transactionType,
      cell: (row) => (
        <span
          className={`badge ${
            row.transactionType === "Debit"
              ? "badge-danger"
              : "badge-success"
          }`}
        >
          {row.transactionType}
        </span>
      ),
    },
  ];
};

export const TopupCreditDataColumns = (region) => [
  {
    name: "S.No",
    cell: (row, index) => (
      <>
        <input type="hidden" value={row.ID} />
        <span>{index + 1}</span>
      </>
    ),
    sortable: false,
  },
  {
    name: "Merchant",
    selector: (row) => row.merchent,
    cell: (row) => (
      <a href={`/view-merchant/${row.merchentId}/topup/${row.merchent}`}>
        <span className="add-ellip wethislink">{row.merchent}</span>
      </a>
    ),
  },
  {
    name: `Amount${region?.currency ? ` (${region.currency})` : ''}`,
    selector: (row) => row.amount,
    cell: (row) => (
      <span className="add-ellip">{safeToFixed(row.amount)}</span>
    ),
  },
  {
    name: "Notes",
    selector: (row) => row.notes,
    cell: (row) => (
      <span className="add-ellip">{row.notes || "-"}</span>
    ),
  },
  {
    name: "Payment Date",
    selector: (row) => row.paymentDate,
  },
  {
    name: "Transaction Type",
    selector: (row) => row.transactionType,
    cell: (row) => (
      <span
        className={`badge ${
          row.transactionType === "Debit"
            ? "badge-danger"
            : "badge-success"
        }`}
      >
        {row.transactionType}
      </span>
    ),
  },
];
